export default __webpack_public_path__ + "static/media/Plus.6e93b582.svg";